window.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    gsap.registerPlugin(ScrollTrigger);

    // // klima device pulse script
    const pulseSections = gsap.utils.toArray(".pulse-section");
    const pulseSectionCenterText = [
      "Boost convenience",
      "Automate climate management",
      "Reduce energy consumption",
    ];
    pulseSections.forEach((section, i) => {
      const sideText = section.querySelectorAll(".pulse-section_number-text");
      const paragraphText = section.querySelectorAll(".pulse-section_p-text");
      const centerTextWrapper = document.querySelector(
        ".pulse-section_image-text"
      );
      const centerText = pulseSectionCenterText[i];
      const spans = centerTextWrapper.querySelectorAll("span");
      const mm = gsap.matchMedia();

      mm.add("(min-width: 768px)", () => {
        gsap.fromTo(
          sideText,
          {
            y: "500vh",
          },
          {
            y: 0,
            scrollTrigger: {
              trigger: section,
              start: "top bottom",
              end: "top top",
              scrub: true,
              toggleActions: true,
            },
          }
        );
        gsap.fromTo(
          paragraphText,
          {
            y: "500vh",
          },
          {
            y: 0,
            scrollTrigger: {
              trigger: section,
              start: "top bottom",
              end: "top top",
              scrub: true,
              toggleActions: true,
            },
          }
        );
        gsap.to(".outer_ring", {
          scrollTrigger: {
            trigger: section,
            toggleActions: "restart none restart none",
            start: "top 5%",
            end: "top -5%",
          },
          duration: 3,
          width: "150vw",
          padding: "75vw 0",
          opacity: 0,
        });
        gsap.to(".inner_ring", {
          scrollTrigger: {
            trigger: section,
            toggleActions: "restart none restart none",
            start: "top 5%",
            end: "top -5%",
            preventOverlaps: true,
          },
          duration: 4,
          width: "150vw",
          padding: "75vw 0",
          opacity: 0,
        });
      });

      mm.add("(max-width: 767px)", () => {
        gsap.fromTo(
          sideText,
          {
            opacity: 0,
          },
          {
            opacity: 1,
            duration: 0.2,
            scrollTrigger: {
              trigger: section,
              start: "top 60%",
              end: "top -5%",
              toggleActions: "play reverse play reset",
            },
          }
        );
        gsap.fromTo(
          paragraphText,
          {
            opacity: 0,
          },
          {
            opacity: 1,
            duration: 0.2,
            scrollTrigger: {
              trigger: section,
              start: "top 30%",
              end: "top -10%",
              toggleActions: "play reverse play reset",
            },
          }
        );
        gsap.to(".outer_ring", {
          scrollTrigger: {
            trigger: section,
            toggleActions: "restart none restart none",
            start: "top 5%",
            end: "top -10%",
          },
          duration: 1,
          width: "150vw",
          padding: "75vw 0",
          opacity: 0,
        });
        gsap.to(".inner_ring", {
          scrollTrigger: {
            trigger: section,
            toggleActions: "restart none restart none",
            start: "top 5%",
            end: "top -5%",
            preventOverlaps: true,
          },
          duration: 2,
          width: "150vw",
          padding: "75vw 0",
          opacity: 0,
        });
      });

      const updateCenterSpanText = () => {
        const words = centerText.split(" ");
        spans.forEach((span, spanIndex) => {
          span.style.opacity = 0;
          span.textContent = words[spanIndex] ? `${words[spanIndex]} ` : "";
        });
      };

      gsap.fromTo(
        spans,
        { opacity: 0, clipPath: "inset(100% 0% 0% 0%)" },
        {
          clipPath: "inset(0% 0% 0% 0%)",
          opacity: 1,
          stagger: 0.1,
          duration: 0.2,
          scrollTrigger: {
            trigger: section,
            // Reverted Changes
            // start: "top 20%",
            start: "top center",
            end: "bottom center",
            toggleActions: "play reset play reset",
            onEnter: updateCenterSpanText,
            onEnterBack: updateCenterSpanText,
          },
        }
      );
    });

    const mm = gsap.matchMedia();
    const sm = gsap.matchMedia();

  }, 500);
});
